export default "__VITE_ASSET__DfwN39fM__"